module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.showData.title,
      "visible": _vm.AddDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.showData.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agent !== ''),
      expression: "agent!==''"
    }]
  }, [_vm._v("独家代理区域：" + _vm._s(this.details.area))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agent !== ''),
      expression: "agent!==''"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("该代理商已付定金：" + _vm._s(this.details.ContractMoney) + "元；订货量：" + _vm._s(this.details.FirstGoodsNum) + "台；已下单55寸：" + _vm._s(this.details.ProNum) + "台;已下单65寸：" + _vm._s(this.details.ProNum65) + "台")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isChoose),
      expression: "isChoose"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择代理商")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "套餐:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": !_vm.isChoose
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.form.PackageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "PackageId", $$v)
      },
      expression: "form.PackageId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "开通班级数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "step": _vm.step,
      "min": _vm.minNum
    },
    model: {
      value: (_vm.form.ClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassNum", $$v)
      },
      expression: "form.ClassNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单价格:"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.price) + "元")]), _vm._v("  (本期应收款:" + _vm._s(_vm.currentPrice) + ";二期应收款:" + _vm._s(_vm.SecondOrderPrice) + ")")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配套实物商品:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proNum",
      "label": "商品数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proNum",
      "label": "本次发货数量"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择收货地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeAddress
    }
  }, [_vm._v("选择地址")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeListName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式:",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.SendMode),
      callback: function($$v) {
        _vm.$set(_vm.form, "SendMode", $$v)
      },
      expression: "form.SendMode"
    }
  }, _vm._l((_vm.transportList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式:",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.PayMode),
      callback: function($$v) {
        _vm.$set(_vm.form, "PayMode", $$v)
      },
      expression: "form.PayMode"
    }
  }, _vm._l((_vm.PayList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": _vm.showData.isReadOnly
    },
    model: {
      value: (_vm.form.OrderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "OrderRemark", $$v)
      },
      expression: "form.OrderRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showData.isReadOnly),
      expression: "!showData.isReadOnly"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  }), _vm._v(" "), _c('AddressDialog', {
    ref: "AddressDialog",
    on: {
      "address": _vm.getAddress,
      "getConsigneeList": _vm.getAgentConsigneeList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bedf51c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/zqwOrder/addSellingOrder/index.vue
// module id = 1405
// module chunks = 1